import { MutatedExperimentVariant } from 'modules/experiments/takeover/types';
import { Nullable } from 'utils/tsHelpers';
import { MutateVariantResponse } from './common';
import {
  VariantFieldValues,
  VariantFormField,
  VariantFormFieldKey,
  VariantZodSchema,
} from './variantCard';

export enum SelectVariantMode {
  PREVIEW = 'preview',
  EDIT = 'edit',
}

export type VariantIssue = {
  errorMessage: string;
  subMessage: string;
};

export type VariantIssues = {
  alphabet: string;
  bgColor: string;
  textColor: string;
  name: string;
  issueList: VariantIssue[];
};

export type VariantConfigurationContextState = {
  isEditSelectMode: boolean;
  isPreviewSelectMode: boolean;
  hasMaximumNumberOfVariants: boolean;
  selectedVariant: Nullable<MutatedExperimentVariant>;
  selectedVariantErrorCount: number;
  variantIssueCount: number;
  variantIssues: VariantIssues[];
  selectMode: SelectVariantMode;
  formFieldSchema: VariantFormField[];
  formFieldZodSchema: VariantZodSchema;
  variantList: MutatedExperimentVariant[];
  addingNewVariant: boolean;
  deletingActiveVariant: boolean;
  setDeletingActiveVariant: (deletingState: boolean) => void;
  addNewVariant: () => Promise<void>;
  deleteExperimentVariant: (
    deleteExperimentVariantProps: DeleteExperimentVariantProps,
    locale: string,
  ) => Promise<boolean>;
  renameExperimentVariant: (variantInfoProps: VariantInfo, locale: string) => Promise<boolean>;
  getPrecedingVariant: (variantId: number) => MutatedExperimentVariant;
  setEditSelectMode: (variant: MutatedExperimentVariant) => void;
  setPreviewSelectMode: (variant: MutatedExperimentVariant) => void;
  toggleToPreviewSelectMode: () => void;
  updateSelectedVariantContent: (fieldName: VariantFormFieldKey, fieldValue: string) => void;
  updateExperimentVariant: (
    variantId: number,
    variantFieldValues: VariantFieldValues,
    showErrorToaster?: boolean,
    updateRedux?: boolean,
  ) => Promise<MutateVariantResponse>;
};

export type DeleteExperimentVariantProps = VariantInfo & {
  onSuccess?: () => void;
};

export type VariantInfo = {
  variantId: number;
  variantName?: string;
};

export type MutateVariant = {
  experimentId: number;
  showSuccessToaster?: boolean;
  showErrorToaster?: boolean;
};
